export default {
  init: function() {
    document.addEventListener('wpcf7mailsent', (event) => {
      const resetForm = function(e) {
        e.preventDefault()
        this.form.classList.remove("sent")
        this.form.classList.add("init")
        this.form.setAttribute("data-status", "init")
        this.msg.textContent = ''
      }

      const customThankYou = event.target.closest("[data-redirect-to]")

      if (
        !!customThankYou
        || window.themeVars.thankYouPageUrl
      ) {
        window.location.href = customThankYou
          ? customThankYou.dataset.redirectTo
          : window.themeVars.thankYouPageUrl
        
        event.target.classList.add("has-redirect")

        return
      }

      // if (window.themeVars.thankYouPageUrl) {
      //   window.location.href = window.themeVars.thankYouPageUrl
      //   event.target.classList.add("has-redirect")

      //   return
      // }

      setTimeout(() => {
        const msg = event.target.querySelector(".wpcf7-response-output")
        const s = event.target.closest("[data-success-heading]")
        const c = event.target.closest("[data-close-msg]")

        if (s) {
          const heading = document.createElement("div")
          heading.classList.add("text-32", "mb-10", "md:mb-20", "font-medium")
          heading.textContent = s.dataset.successHeading
          msg.prepend(heading)
        }

        if (c) {
          const closeBtn = document.createElement("button")
          closeBtn.classList.add("underline", "inline-block", "align-top", "mt-10", "md:mt-20")
          closeBtn.textContent = s.dataset.closeMsg
          msg.appendChild(closeBtn)
          closeBtn.addEventListener("click", resetForm.bind({form: event.target, msg}))
        }

        const formHolder = event.target.closest('.has-contact-form')
        if (formHolder) {
          formHolder.classList.remove("bg-cf")
          formHolder.classList.add("bg-cf-sent")
        }
      })
    }, false)

    // Multistep form

    const multistepFormCounters = [...document.querySelectorAll(".multistep-form__counter")]

    multistepFormCounters.forEach((el) => {
      el.textContent = el.textContent.replace("100", el.closest(".fieldset-cf7mls-wrapper").children.length - 1)
    })
    
    ;[...document.querySelectorAll(".fieldset-cf7mls-wrapper")].forEach((multistepFormWrapper) => {
      const multistepAnswerRadioBtns = [...multistepFormWrapper.querySelectorAll('input[type="radio"]')]
      const updateScore = () => {
        const scoreField = multistepFormWrapper.querySelector('input[name="your-score"]')

        if (scoreField) {
          const sum = multistepAnswerRadioBtns.reduce((prev, btn) => {
            if (btn.checked) {
              const regExp = /\(\+([^)]+)\)/
              const matches = regExp.exec(btn.value)

              if (!!matches) {
                return prev + parseInt(matches[1], 10)
              }
            }

            return prev
          }, 0)

          scoreField.value = sum
        }
      }
      
      updateScore()

      multistepAnswerRadioBtns.forEach((btn) => {
        btn.addEventListener("change", updateScore)
      })
    })
  }
}